import { useTranslations } from 'next-intl'
import styles from './DTPaymentModal.module.css'
import Button, { ButtonKind, ButtonSize } from '@/components/UI/Buttons/Button/Button'
import { useLogout } from '@/apiUtilities/mutations/useLogout'
import { API_Error } from '@/interfaces/api/response/api_response_types'
import { useRouter } from '@/i18n/navigation'
import LinkButton, { LinkButtonKind, LinkButtonSize } from '@/components/UI/Buttons/LinkButton/LinkButton'
import Icon_PaymentOnHold from '@/assets/img/Icon_PaymentOnHold.svg'
import Icon from '@/components/UI/Icon/Icon'
import { getDCBURL } from '@/apiUtilities/requests/dcb'
interface DTPaymentModalProps extends React.HTMLAttributes<HTMLDivElement> {
  checkoutURL: string,
  redirectURL: string,
  billingID: string,
  priceInterval: string,
  onClose: () => void
}

export default function DTPaymentModal ({ onClose, billingID, redirectURL, checkoutURL, priceInterval }: DTPaymentModalProps) {
  const t = useTranslations('Modals.DTPayment')
  const router = useRouter()
  const serverLogout = useLogout()

  /**
   * Cancel payment and close the payment modal
   * 
   * @param e - Mouse click event triggered by cancel button
   */
  function handleCancel (e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault()
    onClose()
  }

  async function handleDCBPayment() {
    const payload = {
      membership_id: billingID + `-${priceInterval}`,
      redirect_url: redirectURL
    }
    const dcbURL = await getDCBURL({ payload: payload })
    window.location.href = dcbURL
  }

  return (
    <div className={styles.main}>
      <Icon icon={Icon_PaymentOnHold} className={styles.cardIcon} />
      <h3 className={`title3 ${styles.title}`}>{t('title')}</h3>
      <p className={`bodyTextLarge ${styles.description}`}>{t('description')}</p>
      <div className={styles.buttons}>
        <Button kind={ButtonKind.PRIMARY} size={ButtonSize.MEDIUM} onClick={handleDCBPayment}>
          {t('payDT')}
        </Button>

        <LinkButton href={checkoutURL} kind={LinkButtonKind.PRIMARY} size={LinkButtonSize.MEDIUM} onClick={onClose}>
          {t('payStripe')}
        </LinkButton>
      </div>
    </div>
  )
}